import script from "./PowerPlantsFilterControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./PowerPlantsFilterControl.vue?vue&type=script&setup=true&lang=ts"

import "./PowerPlantsFilterControl.vue?vue&type=style&index=0&id=ed56b66c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed56b66c"]])

export default __exports__